import { configureStore } from "@reduxjs/toolkit";
import databaseSlice from "./databaseSlice";
import setupsSlice from "./setupsSlice";
import calculatorSlice from "./calculatorSlice";
import uiSlice from "./uiSlice";

export default configureStore({
  reducer: {
    database: databaseSlice,
    setups: setupsSlice,
    calculator: calculatorSlice,
    ui: uiSlice
  }
});
